import { Link } from "react-router-dom";
import logo from "../images/logo.png";

const closeNavbar = () => {
  const navbar = document.getElementById("mainNavbar");
  if (navbar?.classList.contains("show")) {
    navbar.classList.remove("show");
  }
};

function About() {
  return (
    <header>
      <nav className="navbar navbar-expand-md fixed-top bg-light shadow-sm">
        <div className="container">

          {/* Logo + Brand */}
          <Link to="/" className="navbar-brand d-flex align-items-center gap-2">
            <img
              src={logo}
              alt="SkyIndoors Logo"
              style={{ height: "45px", width: "45px" }}
            />
            <span className="fw-bold fs-3">
              <span className="text-primary">Sky</span>
              <span className="text-success">indoors</span>
            </span>
          </Link>

          {/* Mobile Toggle */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNavbar"
            aria-controls="mainNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Menu */}
          <div className="collapse navbar-collapse" id="mainNavbar">
            <ul className="navbar-nav ms-auto fs-5 gap-md-3 text-center">

              <li className="nav-item">
                <Link className="nav-link text-dark" to="/" onClick={closeNavbar}>
                  Home
                </Link>
              </li>

              {/* Services Dropdown */}
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle text-dark"
                  href="#"
                  id="servicesDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Services
                </a>
                <ul className="dropdown-menu shadow-sm">
                  <li><Link className="dropdown-item" to="/windows" onClick={closeNavbar}>Windows</Link></li>
                  <li><Link className="dropdown-item" to="/doors" onClick={closeNavbar}>Doors</Link></li>
                  <li><Link className="dropdown-item" to="/wardrobe" onClick={closeNavbar}>Wardrobe</Link></li>
                  <li><Link className="dropdown-item" to="/cabnet" onClick={closeNavbar}>Kitchen Cabinets</Link></li>
                  <li><Link className="dropdown-item" to="/elevation" onClick={closeNavbar}>Elevation</Link></li>
                  <li><Link className="dropdown-item" to="/partition" onClick={closeNavbar}>Partitions</Link></li>
                  <li><Link className="dropdown-item" to="/" onClick={closeNavbar}>Glass & More</Link></li>
                </ul>
              </li>

              <li className="nav-item">
                <Link className="nav-link text-dark" to="/gallery" onClick={closeNavbar}>
                  Works
                </Link>
              </li>

              <li className="nav-item">
                <a className="nav-link text-dark" href="#contact" onClick={closeNavbar}>
                  Contact Us
                </a>
              </li>

              <li className="nav-item">
                <Link className="nav-link text-dark" to="/about" onClick={closeNavbar}>
                  About Us
                </Link>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default About;
